import React, {useState} from "react"

import LogoProyectoMobile from "./logoMobile.component"
import SelectionBtnsMobile from "./selectionBtnsMobile.component"

import collapse from './../../../UI/general/collapse.svg'

interface SelectionContainerProps {
  data: any,
  handleMenuSelection: any,
  selectionBtnName: string
}

const SelectionContainerMobile = ({data, handleMenuSelection, selectionBtnName}: SelectionContainerProps) => {
  
  const [isSelectionHidden, setSelectionHidden] = useState(false)

  return(
    <React.Fragment>
      <div className={isSelectionHidden ? "selection-bar-mobile-container-collapsed":"selection-bar-mobile"}>
        <LogoProyectoMobile
          logo={data.logo_proyecto}
          handleMenuSelection = {handleMenuSelection}
        />
        <SelectionBtnsMobile
          selectionData={data.menu_btns}
          dataColors = {data.colors}
          selectionBtnName = {selectionBtnName}
          handleMenuSelection = {handleMenuSelection}
        />
      </div>
      <div className={isSelectionHidden ? "collapse-sidebar-mobile-collapsed":"collapse-sidebar-mobile"} onClick={() => {setSelectionHidden(!isSelectionHidden)}}>
        <img src={collapse} alt=""/>
      </div>
    </React.Fragment>
  )
}

export default SelectionContainerMobile